import { useState, useEffect } from "react";
import i18n from "./i18n";

export default function LanguageSwitcher() {
  const [open, setOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("appLanguage") || "sp"
  );

  // Set language from localStorage on mount
  useEffect(() => {
    i18n.changeLanguage(currentLang);
  }, [currentLang]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLang(lng);
    localStorage.setItem("appLanguage", lng);
    setOpen(false);
  };

  return (
    <div className="relative">
      {/* Desktop View */}
      <div className="hidden sm:flex items-center space-x-2">
        <button
          onClick={() => changeLanguage("en")}
          className={`px-2 py-1 text-xs rounded-md ${
            currentLang === "en"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage("sp")}
          className={`px-2 py-1 text-xs rounded-md ${
            currentLang === "sp"
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
          }`}
        >
          ES
        </button>
      </div>

      {/* Mobile View */}
      <div className="sm:hidden relative">
        <button
          onClick={() => setOpen(!open)}
          className="p-2 rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200"
          aria-label="Switch language"
        >
          <i className="ri-global-line text-lg"></i>
        </button>

        {open && (
          <div className="absolute right-0 mt-2 bg-white shadow-lg border border-gray-200 rounded-lg w-24">
            <button
              onClick={() => changeLanguage("en")}
              className={`block w-full text-left px-3 py-1 text-sm rounded-t-md ${
                currentLang === "en"
                  ? "bg-blue-50 text-blue-700 font-medium"
                  : "hover:bg-gray-50"
              }`}
            >
              English
            </button>
            <button
              onClick={() => changeLanguage("sp")}
              className={`block w-full text-left px-3 py-1 text-sm rounded-b-md ${
                currentLang === "sp"
                  ? "bg-blue-50 text-blue-700 font-medium"
                  : "hover:bg-gray-50"
              }`}
            >
              Español
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
